module.exports = __webpack_public_path__ + "img/illu-brain.49eaedac.svg";